/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Kind_DropInputs */

const en_us2_workout_logging_kind_drop = /** @type {(inputs: Workout_Logging_Kind_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop`)
};

const pt_br2_workout_logging_kind_drop = /** @type {(inputs: Workout_Logging_Kind_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop`)
};

const es_419_workout_logging_kind_drop = /** @type {(inputs: Workout_Logging_Kind_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop`)
};

const pt_pt2_workout_logging_kind_drop = /** @type {(inputs: Workout_Logging_Kind_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop`)
};

const fr_fr2_workout_logging_kind_drop = /** @type {(inputs: Workout_Logging_Kind_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dégressive`)
};

const de_de2_workout_logging_kind_drop = /** @type {(inputs: Workout_Logging_Kind_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop`)
};

const it_it2_workout_logging_kind_drop = /** @type {(inputs: Workout_Logging_Kind_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop`)
};

/**
* | output |
* | --- |
* | "Drop" |
*
* @param {Workout_Logging_Kind_DropInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_kind_drop = /** @type {((inputs?: Workout_Logging_Kind_DropInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Kind_DropInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_kind_drop(inputs)
	if (locale === "es-419") return es_419_workout_logging_kind_drop(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_kind_drop(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_kind_drop(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_kind_drop(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_kind_drop(inputs)
	return en_us2_workout_logging_kind_drop(inputs)
});
export { workout_logging_kind_drop as "workout-logging.kind_drop" }